import React from "react";
const Hidden = {
    visibility: 'hidden'
};
const Visible = {
    visibility: 'visible'
};
class ImageWithStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = { imageStatus: "loading", visible: Hidden };
    }
    //componentDidUpdate(prevProps, prevState) {
    //    // Typical usage (don't forget to compare props):
    //    if (this.props.imageUrl !== prevProps.imageUrl) {
    //        this.state = { imageStatus: "loading", visible: Hidden };
    //    }
    //}
    

    handleImageLoaded() {
        this.setState({ imageStatus: "loaded", visible: Visible });
    }

    handleImageErrored() {
        this.setState({ imageStatus: "failed to load" });
    }

    render() {
        return (
          <div>
            <img width={100}
        src={this.props.imageUrl}
        onLoad={this.handleImageLoaded.bind(this)}
                onError={this.handleImageErrored.bind(this)} style={this.state.visible}
            />
          </div>
    );
}
}
export default ImageWithStatus;